import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import MapObjectForm from './MapObjectForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';

import userGroupService from '../../services/authority/userGroupService';
import mapobjectService from './mapObjectService';
import mapObjectCategoryService from '../../services/mapObjectCategoryService';
import locationService from '../../services/locationService';
import publisherService from '../../services/publisherService';
import pageService from '../../services/pageService';
import { ApprovementStatus } from '../contents/ContentPage';

const MapObjectEdit = (props: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);

  const [mapObjectCategories, setMapObjectCategories] = useState<any[]>([]);

  const [entity, setEntity] = useState<any>({
    id: 0,
    name: '',
    imageId: '',
    locationId: '',
    mapObjectCategoryId: '',
    description: '',
    pageId: '',
  });

  const { checkPermission } = useCheckPermission();

  const [pages, setPages] = useState<any[]>([]);
  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    pageService
      .listLastApprovedPages()
      .then((response: any) => {
        if (!response.hasError) setPages(response.records);
        else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const [locations, setLocations] = useState<any[]>([]);
  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    locationService
      .list()
      .then((response: any) => {
        if (!response.hasError) setLocations(response.records);
        else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const [publishers, setPublishers] = useState<any[]>([]);
  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    publisherService
      .list()
      .then((response: any) => {
        if (!response.hasError) {
          setPublishers(response.records);
        } else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  useEffect(() => {
    mapObjectCategoryService.list().then((response: any) => {
      if (!response.hasError) setMapObjectCategories(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    mapobjectService
      .get(params.id)
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          setEntity(response.result);
        }
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, [params.id]);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    mapobjectService
      .update(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <MapObjectForm
      entity={entity}
      pages={pages}
      onPageAdded={(page: any) => {
        setPages([...pages, page]);
      }}
      readonly={!checkPermission(['EditMapObject'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
      locations={locations}
      onLocationAdded={(location: any) => {
        setLocations([...locations, location]);
      }}
      mapObjectCategories={mapObjectCategories}
      onMapObjectCategoryAdded={(category: any) => {
        setMapObjectCategories([...mapObjectCategories, category]);
      }}
      publishers={publishers}
    />
  );
};

export default MapObjectEdit;
